import React from 'react';
import { TextField, Grid } from '@mui/material';
import { LocationPicker } from '../../components/FilterBar/pickers/LocationPicker';
import { DateField } from '../../components/DateField';
import { TimeField } from '../../components/TimeField';

const earliestStartOffset = 60 * 6; // 6am
const latestEndOffset = 60 * 27; // 3am

export interface EventPlanFormEventPlan {
  id?: string;
  name?: string;
  startDate?: Date;
  startOffset?: number;
  endOffset?: number;
  groupSize?: number;
  location?: string;
}

export const EventPlanForm = ({
  eventPlan,
  onChange,
}: {
  eventPlan: EventPlanFormEventPlan;
  onChange: (eventPlan: EventPlanFormEventPlan) => void;
}) => {
  const { name, startDate, startOffset, endOffset, groupSize, location } =
    eventPlan;

  return (
    <Grid container spacing={2} padding="20px 0">
      <Grid item xs={12}>
        <TextField
          label="Event Name"
          required
          value={name}
          fullWidth
          name="name"
          onChange={(e) => {
            onChange({
              ...eventPlan,
              name: e.target.value,
            });
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <DateField
          label="Event Date"
          date={startDate || null}
          onChangeDate={(v) => {
            onChange({
              ...eventPlan,
              startDate: v || undefined,
            });
          }}
        />
      </Grid>
      <Grid item xs={8}>
        <TimeField
          startOffset={startOffset}
          endOffset={endOffset}
          onChange={({ startOffset, endOffset }) => {
            onChange({
              ...eventPlan,
              startOffset,
              endOffset,
            });
          }}
          earliestStartOffset={earliestStartOffset}
          latestEndOffset={latestEndOffset}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Group Size"
          value={groupSize}
          fullWidth
          name="groupSize"
          onChange={(e) => {
            if (e.target.value === '') {
              onChange({
                ...eventPlan,
                groupSize: undefined,
              });
              return;
            }
            if (isNaN(parseInt(e.target.value))) {
              return;
            }
            onChange({
              ...eventPlan,
              groupSize: parseInt(e.target.value),
            });
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <LocationPicker
          locationQuery={location || ''}
          onChangeLocationQuery={(v) => {
            onChange({
              ...eventPlan,
              location: v,
            });
          }}
          shouldShowOutlineSelector={true}
          shouldRenderIcon={false}
          size={'medium'}
        />
      </Grid>
    </Grid>
  );
};
